export enum ELanguageId {
  English = 1,
  Hebrew = 2,
  German = 11,
  French = 10
}
